import React, { PureComponent, Fragment } from 'react';
import $ from 'lodash';
import Cookies from 'js-cookie';
import Walkme from '../../common/walkme';
import Step from '../../common/step';
import { Dialog, Button } from '@tencent/spaui';

import { guidePrefix as prefix } from '../../../consts/prefix';

class Guide extends PureComponent {
  constructor(props) {
    super(props);
    const key = prefix + window.pageProps.uid;
    this.state = {
      showGuide: false,
      showDialog: false, // Cookies.get(key) !== 'showed',
    };
  }

  onClick = () => {
    this.setState({
      showDialog: false,
      showGuide: true,
    });
    Cookies.set(prefix + window.pageProps.uid, 'showed');
  };

  onClose = () => {
    this.setState({
      showDialog: false,
    });
    Cookies.set(prefix + window.pageProps.uid, 'showed');
  };

  onCancel = () => {
    this.setState({
      showDialog: false,
    });
  };

  onComplete = () => {
    window.location.href = '#/fan/official/offocialAccounts';
  };

  onSkip = () => {
    this.setState({
      showGuide: false,
    });
  };

  renderGuide = () =>
    this.state.showGuide ? (
      <Walkme onComplete={this.onComplete} onSkip={this.onSkip}>
        <Step
          key={1}
          title="公众号授权"
          desc="请先新增授权您要运营的公众号"
          placement="right"
          arrowStyle={
            {
              // top: '15px',
            }
          }
          getTarget={() => $('.offocial-Accounts').get(0)}
          getOffsetData={() => ({
            // top: 50,
          })}
        />
        <Step
          key={2}
          title="粉丝管理"
          desc="在这里管理您的公众号粉丝"
          placement="right"
          getTarget={() => $('.fans-manage').get(0)}
        />
        <Step
          key={3}
          title="消息管理"
          desc="可对关注粉丝发送图文消息"
          placement="right"
          getTarget={() => $('.message-manage').get(0)}
        />
      </Walkme>
    ) : null;

  render() {
    return (
      <Fragment>
        <Dialog
          backdrop
          type="normal"
          title="粉丝运营模块上线啦"
          className="dialog-modle-tips"
          style={{ width: '1004px' }}
          hideFooter
          show={this.state.showDialog}
          onClose={this.onClose}
          // onSubmit={this.onClick}
          // onCancel={this.onClose}
          // submitLabel="立即体验"
          // cancelLabel="下次再说"
        >
          <div className="fans-module fans-module-01"></div>
          <div className="fans-module fans-module-02"></div>
          <div className="fans-module fans-module-03"></div>
          <div className="fans-module fans-module-04"></div>
          <div className="fans-module fans-module-05"></div>
          <div className="fans-module fans-module-06"></div>
          <div className="fans-module-btn">
            <Button onClick={() => this.onCancel()} className="fans-module__btn">
              下次再说
            </Button>
            <Button onClick={() => this.onClick()} className="fans-module__btn" displayType="primary">
              立即体验
            </Button>
          </div>
        </Dialog>
        {this.renderGuide()}
      </Fragment>
    );
  }
}

export default Guide;
